/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Container, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Clear';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import { compose } from 'recompose';
import * as app from '../../../../state/ducks/App';
import SearchInput from './SearchInput';
import { GraphqlSimpleProduct } from '../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/GraphqlSimpleProduct';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const PlantsTrendingProductsBuilder = loadable(() => import(/* webpackChunkName: "PlantsTrendingProductsBuilder" */ '../GraphqlCommonComponents/TrendingProducts/PlantsTrendingProductsBuilder'));
const brandSelectors = app?.ducks?.brand?.selectors;

const styles = (theme) => ({
    simpleProduct4row: {
        flex: '0 0 50%',
        maxWidth: '50%',
        marginBottom: '30px',
        position: 'relative',
        width: '100%',
        paddingRight: '10px',
        paddingLeft: '10px',
        [theme.breakpoints.up(769)]: {
            flex: '0 0 25%',
            maxWidth: '25%',
        },
    },
    productRow: {
        boxSizing: 'border-box',
        marginRight: '-10px',
        marginLeft: '-10px',
        width: 'auto',
    },
    fullWidthProductContainer: {
        width: '100%',
        minHeight: '600px',
    },
    warapperBox: {
        paddingTop: '1rem',
    },
    closeButton: {
        float: 'right',
    },
    resultWrapper: {
        paddingTop: '1rem',
    },
    noResultWrapper: {
        width: '100%',
        textAlign: 'center',
    },
    trendingPropductsContainer: {
        paddingTop: '3rem',
    },
});

const PlantsSearchPage = ({
    classes, brand, featureFlags, history,
}) => {
    const [searchResult, setSearchResult] = useState([]);
    const [searchValue, setSearchValue] = useState([]);

    const clearResult = () => {
        if (searchResult?.length === 0) {
            history.goBack();
        } else {
            setSearchResult([]);
        }
    };

    const block = {
        title: 'Top Trending Plants',
        title_font_color: 'black',
        category_id_or_identifier: '/all-plants',
        number_of_products_to_show: '8',
    };

    const topTrendingPlants = () => (<div className={classes.trendingPropductsContainer}><PlantsTrendingProductsBuilder blockData={block} forSearchPage brand={brand} /></div>);

    const defaultSeoData = {
        page_title: brand?.code === 'PLA' ? 'Search | Plants.com' : '',
        meta_description: '',
    };

    return (
        <>
            <>
                <GraphqlSeoHeadTags seoData={defaultSeoData} />
                <Container>
                    <Grid container>
                        <Grid className={classes.fullWidthProductContainer}>
                            <div className={classes.warapperBox}>
                                <Button
                                    className={classes.closeButton}
                                    id="close-search"
                                    data-test="close-button"
                                    name="closeButton"
                                    onClick={clearResult}
                                >
                                    <CloseIcon />
                                </Button>
                                <SearchInput brand={brand} typeSearchBox="desktop" setSearchResult={setSearchResult} history={history} setSearchValue={setSearchValue} />
                                <Grid className={classes.productRow}>
                                    <Grid container className={classes.resultWrapper}>
                                        {
                                            searchResult?.autoSuggest?.products && searchResult?.autoSuggest?.products.map((product) => {
                                                const productName = product?.name;
                                                return (
                                                    <Grid item className={classes.simpleProduct4row}>
                                                        <GraphqlSimpleProduct
                                                            partNumber={product?.partNumber}
                                                            name={productName}
                                                            prices={product?.prices}
                                                            brand={brand}
                                                            image={product?.image}
                                                            url={product?.seo?.url}
                                                            skuPriceRange={product?.skuPriceRange || []}
                                                            availability={product?.availability || false}
                                                            breadCrumbArray={product?.breadCrumbArray || []}
                                                            skipAddons={false}
                                                            showMovieUpsell={false}
                                                            featureFlags={featureFlags}
                                                            isPassportEligible={false}
                                                        />
                                                    </Grid>
                                                );
                                            })
                                        }
                                        { (searchResult?.autoSuggest?.products === null && searchValue !== '') && <div className={classes.noResultWrapper}>Your search &#39; {searchValue} &#39; did not return any results.<>{topTrendingPlants()}</></div> }
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </>
        </>
    );
};

PlantsSearchPage.propTypes = {
    brand: object.isRequired,
    history: object.isRequired,
    classes: object.isRequired,
    featureFlags: object.isRequired,
};
const mapStateToProps = (state) => ({
    brand: brandSelectors?.getBrand(state),
});

const enhance = compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps),
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(PlantsSearchPage);
